import { PropAsset } from './PropAsset';

// Crate - Sandık
// TODO: Replace with SVG asset
export class Crate extends PropAsset {
  readonly id = 'crate';
  readonly width = 24;
  readonly height = 28;
  readonly walkable = false;
  readonly collisionRadius = 0.4;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.fillRect(cx - 9 * s, cy - 3 * s, 18 * s, 6 * s);

    // Main body - Ana gövde
    ctx.fillStyle = '#7b6345';
    ctx.fillRect(cx - 9 * s, cy - 18 * s, 18 * s, 18 * s);

    // Top face (3D effect) - Üst yüz
    ctx.fillStyle = '#8b7355';
    ctx.beginPath();
    ctx.moveTo(cx - 9 * s, cy - 18 * s);
    ctx.lineTo(cx - 6 * s, cy - 21 * s);
    ctx.lineTo(cx + 12 * s, cy - 21 * s);
    ctx.lineTo(cx + 9 * s, cy - 18 * s);
    ctx.closePath();
    ctx.fill();

    // Right face (3D effect) - Sağ yüz
    ctx.fillStyle = '#5b4325';
    ctx.beginPath();
    ctx.moveTo(cx + 9 * s, cy - 18 * s);
    ctx.lineTo(cx + 12 * s, cy - 21 * s);
    ctx.lineTo(cx + 12 * s, cy - 3 * s);
    ctx.lineTo(cx + 9 * s, cy);
    ctx.closePath();
    ctx.fill();

    // Plank lines - Tahta çizgileri
    ctx.strokeStyle = '#4b3315';
    ctx.lineWidth = 1 * s;

    // Horizontal planks
    ctx.beginPath();
    ctx.moveTo(cx - 9 * s, cy - 12 * s);
    ctx.lineTo(cx + 9 * s, cy - 12 * s);
    ctx.moveTo(cx - 9 * s, cy - 6 * s);
    ctx.lineTo(cx + 9 * s, cy - 6 * s);
    ctx.stroke();

    // Vertical center plank
    ctx.beginPath();
    ctx.moveTo(cx, cy - 18 * s);
    ctx.lineTo(cx, cy);
    ctx.stroke();

    // Metal corners - Metal köşeler
    ctx.fillStyle = '#4a4a4a';
    ctx.fillRect(cx - 9 * s, cy - 18 * s, 3 * s, 3 * s);
    ctx.fillRect(cx + 6 * s, cy - 18 * s, 3 * s, 3 * s);
    ctx.fillRect(cx - 9 * s, cy - 3 * s, 3 * s, 3 * s);
    ctx.fillRect(cx + 6 * s, cy - 3 * s, 3 * s, 3 * s);
  }
}
